// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8_pRm","icon":"styles_icon__10-mf"};